/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    OrderVoucher,
    OrderVoucherFromJSON,
    OrderVoucherToJSON,
    OrderVoucherDataFrame,
    OrderVoucherDataFrameFromJSON,
    OrderVoucherDataFrameToJSON,
} from '../models';

export interface ApiOrderVouchersGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiOrderVouchersIdDeleteRequest {
    id: number;
}

export interface ApiOrderVouchersIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiOrderVouchersPostRequest {
    relations?: string;
    deleted?: boolean;
    orderVoucher?: OrderVoucher;
}

/**
 * no description
 */
export class OrderVoucherApi extends runtime.BaseAPI {

    /**
     * Get list of OrderVoucher
     */
    async apiOrderVouchersGetRaw(requestParameters: ApiOrderVouchersGetRequest): Promise<runtime.ApiResponse<OrderVoucherDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderVouchers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderVoucherDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of OrderVoucher
     */
    async apiOrderVouchersGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<OrderVoucherDataFrame> {
        const response = await this.apiOrderVouchersGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of OrderVoucher
     */
    async apiOrderVouchersIdDeleteRaw(requestParameters: ApiOrderVouchersIdDeleteRequest): Promise<runtime.ApiResponse<OrderVoucher>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiOrderVouchersIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderVouchers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderVoucherFromJSON(jsonValue));
    }

    /**
     * Remove entity of OrderVoucher
     */
    async apiOrderVouchersIdDelete(id: number): Promise<OrderVoucher> {
        const response = await this.apiOrderVouchersIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of OrderVoucher
     */
    async apiOrderVouchersIdGetRaw(requestParameters: ApiOrderVouchersIdGetRequest): Promise<runtime.ApiResponse<OrderVoucher>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiOrderVouchersIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderVouchers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderVoucherFromJSON(jsonValue));
    }

    /**
     * Get entity of OrderVoucher
     */
    async apiOrderVouchersIdGet(id: number, relations?: string, deleted?: boolean): Promise<OrderVoucher> {
        const response = await this.apiOrderVouchersIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of OrderVoucher (if id defined)
     */
    async apiOrderVouchersPostRaw(requestParameters: ApiOrderVouchersPostRequest): Promise<runtime.ApiResponse<OrderVoucher>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderVouchers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderVoucherToJSON(requestParameters.orderVoucher),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderVoucherFromJSON(jsonValue));
    }

    /**
     * Create or update entity of OrderVoucher (if id defined)
     */
    async apiOrderVouchersPost(relations?: string, deleted?: boolean, orderVoucher?: OrderVoucher): Promise<OrderVoucher> {
        const response = await this.apiOrderVouchersPostRaw({ relations: relations, deleted: deleted, orderVoucher: orderVoucher });
        return await response.value();
    }

}
